import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { REVENUE_DATA } from '../data/mockData';
export function RevenueChart() {
  return <div className="bg-white rounded-xl soft-shadow p-6 border border-gray-100 h-full flex flex-col" data-id="element-116">
      <h2 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-117">
        7-Day Revenue Trend
      </h2>

      <div className="flex-1 min-h-[180px] w-full" data-id="element-118">
        <ResponsiveContainer width="100%" height="100%" data-id="element-119">
          <AreaChart data={REVENUE_DATA} margin={{
          top: 10,
          right: 0,
          left: -20,
          bottom: 0
        }} data-id="element-120">
            <defs data-id="element-121">
              <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-122">
                <stop offset="5%" stopColor="var(--accent-color)" stopOpacity={0.3} data-id="element-123" />
                <stop offset="95%" stopColor="var(--accent-color)" stopOpacity={0.05} data-id="element-124" />
              </linearGradient>
            </defs>
            <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{
            fill: '#9CA3AF',
            fontSize: 12
          }} dy={10} data-id="element-125" />
            <YAxis axisLine={false} tickLine={false} domain={[0, 1]} ticks={[0, 0.25, 0.5, 0.75, 1]} tick={{
            fill: '#9CA3AF',
            fontSize: 12
          }} tickFormatter={value => `₹${value}L`} data-id="element-126" />
            <Tooltip contentStyle={{
            borderRadius: '8px',
            border: 'none',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }} formatter={(value: number) => [`₹${value} Lakhs`, 'Revenue']} data-id="element-127" />
            <Area type="monotone" dataKey="revenue" stroke="var(--accent-color)" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" data-id="element-128" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>;
}